import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute() {
  const { status } = useAuth();
  const location = useLocation();
  if (status === "checking") {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center" data-testid="auth-checking">
        <div className="flex items-center gap-2 text-zinc-500 font-mono text-[12px]">
          <span className="w-1.5 h-1.5 bg-orange-500 rounded-full tx-pulse-dot" />
          restoring session…
        </div>
      </div>
    );
  }
  if (status === "anon") return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return <Outlet />;
}
